import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_6";
import BlockSecondary from "../components/block/Block_11";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[10] : rpdata?.stock?.[4]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[3] : rpdata?.stock?.[4]}
          image1={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[11] : rpdata?.stock?.[4]}
          image3={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[16] : rpdata?.stock?.[4]}
          image2={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[24] : rpdata?.stock?.[4]}
          image4={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[23] : rpdata?.stock?.[4]}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[6] : rpdata?.stock?.[4]}
          image1={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[7] : rpdata?.stock?.[4]}
          image2={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[8] : rpdata?.stock?.[4]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[9] : rpdata?.stock?.[4]}
          image3={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[8] : rpdata?.stock?.[4]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
